<template>
    <div class="timeline-container">
        <div class="sa-timeline">
            <ul class="sa-timeline-ul">
                <li :style="getColor(letto)" v-for="letto in letti" :key="letto.id">
                    <div class="date">{{ formatDateTime(letto.dataOra) }}</div>
                    <div class="title">Stato: {{ letto.stato }}</div>
                    <div class="descr" v-if="letto.stato === 'OCCUPATO'">Numero cartella: {{ letto.numeroCartella }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsapostilettolettostatistorico",
            pathResourceUserData: "/rsapostilettoletti",
            idLetto: null,
            jsonData: {
                username: null,
            },
            letti: [],
        };
    },
    mounted() {},
    computed: {},
    methods: {
        getColor(letto) {
            let returnValue = "--accent-color: #41516c";
            switch (letto.stato) {
                case "OCCUPATO":
                    returnValue = "--accent-color: #d32f2f";
                    break;
                case "LIBERO":
                    returnValue = "--accent-color: #388e3c";
                    break;
                case "DISPONIBILE":
                    returnValue = "--accent-color: #1976d2";
                    break;
                case "PRENOTATO":
                    returnValue = "--accent-color: #ffa000";
                    break;
                case "SOSPESO":
                    returnValue = "--accent-color: #757575";
                    break;
                default:
                    returnValue = "--accent-color: #41516c";
            }
            return returnValue;
        },
        loadData(id) {
            this.idLetto = id;
            this.loadStoricoLetto();
        },
        loadStoricoLetto() {
            let me = this;
            me.showModalLoading = true;
            UtilityMixin.methods.loadDataResources(me.pathResource, { idLetto: me.idLetto }, me.loadStoricoLettoSuccess, me.loadStoricoLettoError);
        },
        loadStoricoLettoSuccess(response) {
            let me = this;
            me.letti = response.data.data.list;
            me.showModalLoading = false;
            me.$emit("afterLoadData");
        },
        loadStoricoLettoError(error) {
            let me = this;
            console.error(error);
            me.showModalLoading = false;
        },
        onRefresh() {
            let me = this;
            me.loadStoricoLetto();
        },
    },
};
</script>
<style scoped>
.timeline-container {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
